// Rental agreement text shown on the Review step and saved with each booking.
// Bump AGREEMENT_VERSION whenever the legal language below changes so historical
// bookings record exactly which version the renter agreed to.
//
// Recommended: have an attorney review this language before going live.

export const AGREEMENT_VERSION = '2026-04-22.2';

export const RENTAL_AGREEMENT_SECTIONS = [
     {
          heading: '1. Equipment Condition & Acceptance',
          body:
               'I acknowledge that all equipment is received in good working condition unless otherwise noted at the time of pickup or delivery. I accept full responsibility for the equipment during the rental period.',
     },
     {
          heading: '2. Replacement, Damage, and Loss of Use',
          body:
               'I agree to pay the full replacement cost of any equipment that is lost, stolen, not returned, or damaged beyond repair. I agree to pay for all repairs required due to misuse, neglect, or operator error. If equipment is damaged and unavailable for rental, I agree to pay for loss of use at the applicable daily rental rate until the equipment is repaired or replaced.',
     },
     {
          heading: '3. Payment Authorization',
          body:
               'I authorize Ripout Rentals™ to charge the card on file for any amounts owed under this agreement, including but not limited to: rental extensions, damage, cleaning fees, replacement costs, and any unpaid balances.',
     },
     {
          heading: '4. Liability & Indemnification',
          body:
               'I assume all risks associated with the use, handling, and operation of the equipment. To the fullest extent permitted by law, I agree to release, indemnify, and hold harmless Ripout Rentals™, its owners, employees, and affiliates from any claims, damages, losses, or expenses arising from my use of the equipment, except to the extent caused by Ripout Rentals™\' gross negligence or willful misconduct.',
     },
     {
          heading: '5. Limitation of Liability',
          body:
               'To the fullest extent permitted by law, Ripout Rentals™ shall not be liable for any indirect, incidental, or consequential damages, including but not limited to project delays, lost profits, or business interruption. Any liability is limited to the total amount paid for the rental.',
     },
     {
          heading: '6. Operator Requirements',
          body:
               'I confirm I am at least 18 years of age and physically and mentally capable of safely operating the equipment. I am responsible for any third party I allow to use the equipment, and all terms of this agreement apply to them.',
     },
     {
          heading: '7. Proper Use & Prohibited Use',
          body:
               'Equipment must be used only for its intended purpose and in accordance with all safety guidelines and applicable laws. The equipment may not be used for illegal purposes or in any way that could cause damage, injury, or excessive wear.',
     },
     {
          heading: '8. No Modifications or Repairs',
          body:
               'I will not modify, disassemble, or attempt to repair the equipment. Any service issues must be reported immediately to Ripout Rentals™.',
     },
     {
          heading: '9. Return Condition',
          body:
               'Equipment must be returned clean and in the same condition it was received, normal wear and tear excepted. A cleaning fee of up to $75 may be charged if equipment is returned with excessive dust, debris, or material buildup. Dump trailers may not be used to transport tile, demolition debris, or similar materials unless explicitly authorized. Violation voids any delivery or haul-away service with no refund.',
     },
     {
          heading: '10. Rental Period & Late Returns',
          body:
               'Equipment not returned by the agreed time will be charged at the standard daily rental rate for each additional day until returned. Extensions must be approved in advance.',
     },
     {
          heading: '11. Site Conditions & Responsibility',
          body:
               'I am responsible for ensuring the jobsite has adequate power, water, ventilation, and safe access. I am also responsible for protecting my own property and surrounding areas from dust, debris, and damage.',
     },
     {
          heading: '12. Assumption of Risk',
          body:
               'I understand that tile and flooring removal involves inherent risks, including silica dust exposure, flying debris, noise, vibration, heavy lifting, and potential property damage. I accept all such risks and confirm I have reviewed or understand proper equipment operation and safety procedures.',
     },
     {
          heading: '13. Insurance',
          body:
               'I acknowledge that Ripout Rentals™ does not provide insurance coverage for the equipment or its use. I am responsible for maintaining any insurance I deem necessary.',
     },
     {
          heading: '14. Default, Collections, and Legal Fees',
          body:
               'If I fail to pay any amounts owed, I agree to pay all costs of collection, including reasonable attorney\'s fees, court costs, and collection agency fees.',
     },
     {
          heading: '15. Governing Law & Severability',
          body:
               'This agreement is governed by the laws of the State of Arizona, with venue in Maricopa County, Arizona. If any provision is found unenforceable, the remaining provisions shall remain in full force.',
     },
     {
          heading: '16. Electronic Signature',
          body:
               'By agreeing to this document, I consent to the use of electronic signatures in accordance with the E-SIGN Act, and agree this is legally binding.',
     },
];
